// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `voucher-receipt .voucher-card {
  overflow: hidden;
  border-radius: var(--border-radius);
  color: var(--motes-white);
  transition: 0.2s;
}
voucher-receipt .voucher-card .voucher-content {
  opacity: 1;
  transition: 0.2s;
  background-color: var(--motes-dark-gray);
}
voucher-receipt .voucher-card .voucher-content light-image .image-container {
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}
voucher-receipt .voucher-card .voucher-content .voucher-options {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--large-spacing);
  box-sizing: border-box;
}
voucher-receipt .voucher-card .voucher-content .voucher-options ol {
  padding: 0 25px;
  width: 85%;
}
voucher-receipt .voucher-card .voucher-content .voucher-options ol li {
  padding-left: var(--small-spacing);
}
voucher-receipt .voucher-card .voucher-content .voucher-options ol li:not(:last-child) {
  margin-bottom: 30px;
}
voucher-receipt .voucher-card .voucher-content .voucher-options ol li .download-buttons {
  padding-top: var(--small-spacing);
  display: flex;
  gap: var(--small-spacing);
  opacity: 0;
  transition: 0.2s opacity;
  aspect-ratio: 16/3;
}
voucher-receipt .voucher-card .voucher-content .voucher-options ol li .download-buttons.loaded {
  opacity: 1;
}
voucher-receipt .voucher-card .voucher-content .voucher-options ol li .download-buttons picture {
  display: flex;
  flex: 1;
  max-width: 150px;
}
voucher-receipt .voucher-card .voucher-content .voucher-options ol li .download-buttons img {
  cursor: pointer;
  width: 100%;
  object-fit: contain;
}
voucher-receipt .voucher-card .voucher-content .voucher-options ol li .claim-code {
  font-size: 35px;
  line-height: 50px;
  color: var(--primary-color);
  font-weight: bold;
  margin-top: var(--small-spacing);
}
voucher-receipt .voucher-card .voucher-content .voucher-options.qr-sharing {
  text-align: center;
}
voucher-receipt .voucher-card .voucher-content .voucher-options button {
  margin: 0 auto;
}
voucher-receipt .voucher-card .voucher-content .voucher-options svg-qrcode .qr-code {
  margin-top: var(--large-spacing);
}
voucher-receipt .voucher-card .voucher-content .voucher-options svg-qrcode .qr-code canvas {
  height: 200px;
}
voucher-receipt .voucher-card .voucher-content .voucher-options a {
  color: var(--primary-color);
  display: block;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  word-wrap: break-word;
}
voucher-receipt .voucher-card.loading {
  background: linear-gradient(-45deg, var(--motes-black), var(--motes-dark-gray));
  background-size: 400% 400%;
  animation: gradient 2s ease infinite;
}
voucher-receipt .voucher-card.loading .voucher-content {
  background-color: transparent;
}
voucher-receipt .voucher-card.loading .voucher-content light-image {
  opacity: 0;
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/voucher-receipt/voucher-receipt.component.scss"],"names":[],"mappings":"AAEI;EACI,gBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;AADR;AAGQ;EACI,UAAA;EACA,gBAAA;EACA,wCAAA;AADZ;AAGY;EACI,4DAAA;AADhB;AAIY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AAFhB;AAIgB;EACI,eAAA;EACA,UAAA;AAFpB;AAIoB;EACI,kCAAA;AAFxB;AAIwB;EACI,mBAAA;AAF5B;AAKwB;EACI,iCAAA;EACA,aAAA;EACA,yBAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;AAH5B;AAK4B;EACI,UAAA;AAHhC;AAM4B;EACI,aAAA;EACA,OAAA;EACA,gBAAA;AAJhC;AAO4B;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AALhC;AASwB;EACI,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,iBAAA;EACA,gCAAA;AAP5B;AAYgB;EACI,kBAAA;AAVpB;AAagB;EACI,cAAA;AAXpB;AAcgB;EACI,gCAAA;AAZpB;AAcoB;EACI,aAAA;AAZxB;AAgBgB;EACI,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AAdpB;AAoBQ;EACI,+EAAA;EACA,0BAAA;EACA,oCAAA;AAlBZ;AAoBY;EACI,6BAAA;AAlBhB;AAoBgB;EACI,UAAA;AAlBpB;AAuBQ;EACI;IACI,2BAAA;EArBd;EAuBU;IACI,6BAAA;EArBd;EAuBU;IACI,2BAAA;EArBd;AACF","sourcesContent":["voucher-receipt {\n\n    .voucher-card {\n        overflow: hidden;\n        border-radius: var(--border-radius);\n        color: var(--motes-white);\n        transition: 0.2s;\n    \n        .voucher-content {\n            opacity: 1;\n            transition: 0.2s;\n            background-color: var(--motes-dark-gray);\n\n            light-image .image-container {\n                border-radius: var(--border-radius) var(--border-radius) 0 0; // Necessary for Safari\n            }\n            \n            .voucher-options {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                padding: var(--large-spacing);\n                box-sizing: border-box;\n\n                ol {\n                    padding: 0 25px;\n                    width: 85%;\n\n                    li {\n                        padding-left: var(--small-spacing);\n\n                        &:not(:last-child) {\n                            margin-bottom: 30px;\n                        }\n\n                        .download-buttons {\n                            padding-top: var(--small-spacing);\n                            display: flex;\n                            gap: var(--small-spacing);\n                            opacity: 0;\n                            transition: 0.2s opacity;\n                            aspect-ratio: 16 / 3; // Approx ratio when containing two download buttons (prettier loading)\n\n                            &.loaded {\n                                opacity: 1;\n                            }\n\n                            picture {\n                                display: flex;\n                                flex: 1;\n                                max-width: 150px;\n                            }\n\n                            img {\n                                cursor: pointer;\n                                width: 100%;\n                                object-fit: contain;\n                            }\n                        }\n\n                        .claim-code {\n                            font-size: 35px;\n                            line-height: 50px;\n                            color: var(--primary-color);\n                            font-weight: bold;\n                            margin-top: var(--small-spacing);\n                        }\n                    }\n                }\n\n                &.qr-sharing {\n                    text-align: center;\n                }\n\n                button {\n                    margin: 0 auto;\n                }\n\n                svg-qrcode .qr-code {\n                    margin-top: var(--large-spacing);\n                    \n                    canvas {\n                        height: 200px;\n                    }\n                }\n\n                a {\n                    color: var(--primary-color);\n                    display: block;\n                    text-align: center;\n                    width: fit-content;\n                    max-width: 100%;\n                    margin: 0 auto;\n                    word-wrap: break-word;\n                }\n            }\n        }\n\n        // Pulsating background while voucher is loading\n        &.loading {\n            background: linear-gradient(-45deg, var(--motes-black), var(--motes-dark-gray));\n            background-size: 400% 400%;\n            animation: gradient 2s ease infinite;\n\n            .voucher-content {\n                background-color: transparent;\n\n                light-image {\n                    opacity: 0;\n                }\n            }\n        }\n\n        @keyframes gradient {\n            0% {\n                background-position: 0% 50%;\n            }\n            50% {\n                background-position: 100% 50%;\n            }\n            100% {\n                background-position: 0% 50%;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
